var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H6.01M6 18H6.01M5.2 10H18.8C19.92 10 20.48 10 20.908 9.782C21.284 9.59 21.59 9.284 21.782 8.908C22 8.48 22 7.92 22 6.8V5.2C22 4.08 22 3.52 21.782 3.092C21.59 2.716 21.284 2.41 20.908 2.218C20.48 2 19.92 2 18.8 2H5.2C4.08 2 3.52 2 3.092 2.218C2.716 2.41 2.41 2.716 2.218 3.092C2 3.52 2 4.08 2 5.2V6.8C2 7.92 2 8.48 2.218 8.908C2.41 9.284 2.716 9.59 3.092 9.782C3.52 10 4.08 10 5.2 10ZM13.5 22H5.2C4.08 22 3.52 22 3.092 21.782C2.716 21.59 2.41 21.284 2.218 20.908C2 20.48 2 19.92 2 18.8V17.2C2 16.08 2 15.52 2.218 15.092C2.41 14.716 2.716 14.41 3.092 14.218C3.52 14 4.08 14 5.2 14H13.5M18.5 22V13.5M15 17L18.5 13.5L22 17",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsg);
export default __webpack_public_path__ + "static/media/asg.fa49289e1b2a16e530420663acd4246b.svg";
export { ForwardRef as ReactComponent };